// src/components/BusinessCardFlow/utils/imageUtils.js
import imageCompression from 'browser-image-compression';

/**
 * Compress an image to about 0.5MB or max 1280px, whichever is smaller,
 * then return base64 string.
 */
export async function fileToCompressedBase64(file) {
  const options = { maxSizeMB: 0.5, maxWidthOrHeight: 1280, useWebWorker: true };
  const compressedFile = await imageCompression(file, options);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(compressedFile);
  });
}
